import React from 'react';
import PropTypes from 'prop-types';
import './UserDetailsModal.css';

/**
 * UserDetailsModal Component
 * Displays detailed Symphony Summit user information in a modal overlay
 */
const UserDetailsModal = ({ userData, email, onClose }) => {
  // Handle ESC key to close modal
  React.useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [onClose]);

  if (!userData) {
    return null;
  }

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="modal-title">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h3 id="modal-title">Symphony Summit User Details</h3>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            ×
          </button>
        </div>

        <div className="modal-body">
          <div className="user-detail-row">
            <span className="detail-label">Email:</span>
            <span className="detail-value">{userData.EmailID || email}</span>
          </div>
          <div className="user-detail-row">
            <span className="detail-label">User Name:</span>
            <span className="detail-value">{userData.UserName || 'N/A'}</span>
          </div>
          {userData.UserID && (
            <div className="user-detail-row">
              <span className="detail-label">User ID:</span>
              <span className="detail-value">{userData.UserID}</span>
            </div>
          )}
          {userData.Mobile && (
            <div className="user-detail-row">
              <span className="detail-label">Mobile:</span>
              <span className="detail-value">{userData.Mobile}</span>
            </div>
          )}
          {userData.Department && (
            <div className="user-detail-row">
              <span className="detail-label">Department:</span>
              <span className="detail-value">{userData.Department}</span>
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button className="modal-button" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

UserDetailsModal.propTypes = {
  userData: PropTypes.object,
  email: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired
};

export default UserDetailsModal;
